export const addPaymentMethodURL = '/payment/user/add/payment-method'
export const removeCardURL = '/payment/user/delete/payment-method'
export const getCardsURL = '/payment/user/get/payment-methods'
export const saveDefaultCardsURL = '/payment/v1/user/default/card'
